import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { callDepartmentMain, callUserObjective, callUserObjective3 } from "../request/request.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { putField } from "../../../../utils/form";

export const createColumns = ({ props }) => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.inform.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.inform.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.inform.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.inform.invoiceCode"),
            dataIndex: "products.invoiceCode",
            dataIndexValue: ({ record }) => record.products.map(d => d.invoiceCode).join("\r\n"),
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["16", "17", "02"].some(d => props.requestDocKeys.includes(d)),
            title: () => i18n.global.t("model.inform.eformCode"),
            dataIndex: "eformCode",
            align: "center"
        }),
        createColumnSelect({
            visible: () => ["16", "17", "18", "19"].some(d => props.requestDocKeys.includes(d)),
            title: () => i18n.global.t("model.inform.refOperation"),
            dataIndex: "refOperation.value",
            customRender: ({ record }) => <div>{record.refOperation?.value}</div>,
            inputProp: () => ({
                list: ({ searchQuery }) =>
                    ["16", "17"].some(d => props.requestDocKeys.includes(d))
                        ? callUserObjective({ searchQuery })
                        : callUserObjective3({ searchQuery }),
                optLabel: "value"
            }),
            align: "center",
            search: {
                visible: () => ["16", "17", "18", "19"].some(d => props.requestDocKeys.includes(d)),
                name: "refOperation.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.inform.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartmentMain, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.inform.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: {
                name: "refStatus.id"
            }
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
